import { useEffect, useState } from 'preact/hooks'
import { useAppContext } from '../contexts/AppContext'
import { checkCompletionKeywords } from '../services/completionKeywordsService'

function useCompletionKeywordsState() {
  const [completionKeywordsState, setCompletionKeywordsState] = useState(false)
  const { actionCardService, completionKeywords } = useAppContext()

  useEffect(() => {
    adjustCompletionKeywordsState()

    window.addEventListener('actioncard-change', adjustCompletionKeywordsState)
    return () => {
      window.removeEventListener('actioncard-change', adjustCompletionKeywordsState)
    }
  }, [actionCardService])

  function adjustCompletionKeywordsState() {
    const keywords = actionCardService.getActionCardModel()?.getActiveTagNames()
    setCompletionKeywordsState(checkCompletionKeywords(keywords, completionKeywords))
  }

  return completionKeywordsState
}

export default useCompletionKeywordsState
